<template>
  <div>
    <div class="md:flex md:flex-col">
      <div class="md:h-screen md:flex md:flex-col">
        <div class="md:flex md:flex-shrink-0">
          <div class="border-b w-full p-4 md:py-0 md:px-12 text-sm md:text-md flex justify-between items-center" style="border: none; z-index: 1;">
            <div class="flex w-72 py-4">
              <inertia-link class="btn-indigo" :href="route('dashboard')">
                <icon class="w-5 h-5 fill-white" name="return" />
              </inertia-link>
            </div>

            <div class="m-auto">
              <inertia-link :href="route('indicators.start')">
                <img :src="'/logo.png'" alt="Logo" width="100" />
              </inertia-link>
            </div>

            <div class="flex items-center select-none group">
              <div class="text-white mr-1 whitespace-nowrap">
                <span>Olá, <strong class="text-indigo">{{ $page.props.auth.user.first_name }}</strong></span>
                <span class="hidden md:inline"><strong class="text-indigo">{{ $page.props.auth.user.last_name }}</strong></span>
              </div>

              <inertia-link v-if="$page.props.auth.user.roles.includes('indicators-order')" :href="route('indicators.config')">
                <icon class="w-5 h-5 ml-3 fill-white" name="gear" />
              </inertia-link>
            </div>
          </div>
        </div>

        <div class="bg-indicator md:flex md:flex-grow md:overflow-hidden" style="margin-top: -10vh;">
          <div class="md:flex-1 px-4 py-8 md:p-12 md:overflow-y-auto mt-24 ml-32" scroll-region>
            <div v-for="(row, line) in 2" :key="`row-${row}`" class="mt-4 flex flex-wrap">
              <inertia-link
                v-for="(menu, index) in menus[line]"
                :key="menu.icon"
                class="max-w-sm rounded shadow-lg overflow-hidden w-1/3 m-4"
                :class="{
                  'ml-auto': index === 0,
                  'mr-auto': index === menus[line].length - 1,
                  'bg-gray-800': menu.icon !== 'SET-mini',
                  'bg-gray-200': menu.icon === 'SET-mini'
                }"
                :href="route('indicators', { menu: menu.icon })"
              >
                <div class="px-6 py-4">
                  <div class="font-bold text-xl mb-2 text-center">
                    <img
                      :src="`/i-${menu.file}.png`"
                      class="h-24 mb-2 mx-auto"
                      :class="{'w-24': menu.file !== 'SET'}"
                    />
                  </div>

                  <p class="text-indigo text-sm text-center">
                    {{ menu.label }}
                  </p>
                </div>
              </inertia-link>
            </div>

            <div class="mt-4 flex flex-wrap">
              <inertia-link
                class="max-w-sm rounded shadow-lg overflow-hidden w-1/3 m-4 mx-auto bg-gray-800"
                :href="route('indicators', { menu: 'chart' })"
              >
                <div class="px-6 py-4">
                  <div class="font-bold text-xl mb-2 text-center">
                    <img
                      src="/i-chart.png"
                      class="w-24 h-24 mb-2 mx-auto"
                    />
                  </div>

                  <p class="text-indigo text-sm text-center">
                    Pesquisa de Demanda
                  </p>
                </div>
              </inertia-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
  },
  data() {
    return {
      get menus() {
        return [
          [
            {
              icon: 'flag',
              file: 'flag',
              label: 'Território',
            },
            {
              icon: 'bus',
              file: 'bus',
              label: 'Transporte',
            },
            {
              icon: 'briefcase',
              file: 'briefcase',
              label: 'Emprego',
            },
          ],
          [
            {
              icon: 'invoice',
              file: 'invoice',
              label: 'Financeiro',
            },
            {
              icon: 'departure',
              file: 'departure',
              label: 'Turismo',
            },
            {
              icon: 'SET-mini',
              file: 'SET',
              label: 'RADAR SET - DTI',
            },
          ],
        ]
      },
    }
  },
}
</script>
